import * as actionTypes from '../actionTypes';


const reducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_USER_STATEMENT_REDUCER:
            state = {
                ...state,
                ...action.payload,
            }
            break;
        default:
            state = { ...state };
    }
    return state;
}

export default reducer;
